import { render, staticRenderFns } from "./ApplicationAttachments.vue?vue&type=template&id=6f8ad80e&"
import script from "./ApplicationAttachments.vue?vue&type=script&lang=js&"
export * from "./ApplicationAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports